<div class="d-flex h-100">
  <div class="m-auto text-center">
    <ng-lottie class="d-flex align-self-center" [options]="options"></ng-lottie>
    <h1 class="fs-1 lh-1">Errore improvviso!</h1>
    <a class="btn btn-outline-danger mt-4" routerLink="" >Ritorna alla home!</a>
  </div>
</div>
